import { IComponentOptions, IController, IOnChangesObject } from 'angular';
import { IFontFamilyModel } from '../../classes';
import { FontFamilyService, ITrial, TrialService } from '../../providers';
import template from './desktop-trial-button.html';
import { DesktopPopoverController } from './desktop-trial-popover';

export class DesktopTrialButtonController implements IController {
    // bindings
    // familyId to start a trial for, will be overridden by family
    familyId?: number;
    // family model to start a trial for, takes precedence over familyId
    family?: IFontFamilyModel;

    // locals
    popoverController?: DesktopPopoverController;
    // indicates a user already has a trial for this family.
    hasTrial = false;
    trials: ITrial[] = [];
    selectedFamily?: IFontFamilyModel;

    static $inject = ['trialService', 'FontFamilyService'];
    constructor(
        protected trialService: TrialService,
        protected familyService: FontFamilyService
    ) {}

    $onInit(): void {
        this.trialService.trials$.subscribe((trials) => {
            this.trials = trials;
            this._updateHasTrial();
        });
    }

    $onChanges(changes: IOnChangesObject): void {
        // console.log('changes', changes);
        const family = changes.family;
        if (family && family.currentValue !== family.previousValue) {
            // set selected family.
            this.selectedFamily = family.currentValue;
            // update when family change
            this._updateHasTrial();
        }

        const familyId = changes.familyId;
        if (
            !this.family &&
            familyId &&
            familyId.currentValue !== familyId.previousValue
        ) {
            // give family priority
            // we do not set selectedFamily here because we don't have the family model, and want to defer any lookup to the button click  so we don't slow initial rendering
            // and data loads.
            this._updateHasTrial();
        }
    }

    _updateHasTrial(): void {
        const familyId = this.family?.id || this.familyId || undefined;
        this.hasTrial =
            !!familyId &&
            this.trials.some((trial) => {
                return trial.family_id === familyId;
            });
    }

    clicked($event: Event): void {
        $event.preventDefault();
        if (!this.family && !this.familyId) {
            throw new Error('No family or familyId');
        }

        if (this.family) {
            // selected family should be set by $onChanges
            this.showPopover($event);
            return;
        }

        if (this.familyId) {
            // defer family load until the button is pushed, by then
            //  they're likely already inflight or loaded.
            this.familyService.get(this.familyId).then((family) => {
                if (this.popoverController)
                    this.popoverController.family = family;
                this.selectedFamily = family;
                this.showPopover($event);
            });
        }
    }

    showPopover($event: Event): void {
        if (this.popoverController == undefined) {
            throw new Error('No popover controller');
        }
        this.popoverController.show($event.currentTarget);
    }
}

export const DesktopTrialButtonComponent: IComponentOptions = {
    bindings: {
        // you can pass a familyId if you don't have the full family model.
        // family will take precedence if both are passed.
        familyIds: '<?',
        // you can pass a family models if you have it
        family: '<?',
    },
    controller: DesktopTrialButtonController,
    template,
};
